const calculateTripSum = (list) => {
  let sum = 0;
  if (list) {
    list.forEach((entry) => {
      sum = sum + +entry.duration;
    });
  }

  return sum;
};

export default calculateTripSum;
